import React, { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getProductDetails, GetSellerProducts } from "../../services/products.service";
// import { sendWhatsappMessage } from "../../services/message.service";
import { ROLE } from "../../../../utils/Constants";
import { getUser } from "../../../../utils/commonfunction";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import AvatarImage from "../../../user/components/AvatarImage";
import ShareModal from "../../../user/components/ShareModal";
import { Share2 } from "lucide-react";
import { getColorPalettes } from "../../../user/services/stream.service";
import { getColorDotStyle } from "../../../admin/common/colorPalettePicker";
import ProductImageZoomer from "../../../user/components/ProductImageZoomer";

const isVideoMedia = (item) => {
  if (!item) return false;
  if (typeof item === "string") {
    return /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?.*)?$/i.test(item);
  }
  if (item.type === "video" || item.isVideo) return true;
  if (item.url && /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?.*)?$/i.test(item.url)) return true;
  return false;
};

const getCompressedImageUrl = (img) => {
  if (!img) return "";
  if (typeof img === "object") {
    if (img.compressed_url) return img.compressed_url;
    if (img.compressed) {
      if (typeof img.compressed === "string" && img.compressed.startsWith("http")) return img.compressed;
      return img.compressed;
    }
    if (img.compressed_image) return img.compressed_image;
    if (img.url) return getCompressedImageUrl(img.url);
    return "";
  }
  if (typeof img === "string") {
    if (img.includes("compressed_")) return img;
    const lastSlash = img.lastIndexOf("/");
    if (lastSlash !== -1) {
      const dir = img.substring(0, lastSlash + 1);
      const filename = img.substring(lastSlash + 1);
      const dot = filename.lastIndexOf(".");
      const nameWithoutExt = dot !== -1 ? filename.substring(0, dot) : filename;
      return `${dir}compressed_${nameWithoutExt}.webp`;
    }
    return img;
  }
  return "";
};

const getAttributeLabel = (key, t) => {
  const normalized = String(key || "").toLowerCase().trim();
  let labelKey = normalized.replace(/\s+/g, "_");
  if (normalized.includes("color") || normalized.includes("colour")) {
    labelKey = "colors";
  }
  return t(`product_details.attribute_labels.${labelKey}`, { defaultValue: key });
};

function Details() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [productsList, setProductsList] = useState([]);
  const [showShareModal, setShowShareModal] = useState(false);
  const sliderRef = useRef(null);

  const handleColorClick = (colorName) => {
    if (!product || !product.images || !colorName) return;
    const index = product.images.findIndex(img => {
      if (!img.color) return false;
      return img.color.toLowerCase().trim() === colorName.toLowerCase().trim();
    });
    if (index !== -1) {
      setActiveImageIndex(index);
    }
  };

  const handlePrevImage = () => {
    if (!product || !product.images || product.images.length <= 1) return;
    setActiveImageIndex(prev => (prev === 0 ? product.images.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    if (!product || !product.images || product.images.length <= 1) return;
    setActiveImageIndex(prev => (prev === product.images.length - 1 ? 0 : prev + 1));
  };

  const [colorPalettes, setColorPalettes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const users = getUser(ROLE.USER);
  const o_id = searchParams.get("o_id");


  const phone_number = users?.phone_number?.replace(/\D/g, "");
  console.log(phone_number,"csd12121212");
  
  useEffect(() => {
    const fetchProductDetails = async () => {
      if (!o_id) {
        setError("Product ID not found");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await getProductDetails(o_id);

        if (response.success) {
          setProduct(response.data);
          setError(null);
        } else {
          setError(response.message || "Failed to fetch product details");
        }
      } catch (err) {
        console.error("Error fetching product details:", err);
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchProductDetails();
  }, [o_id]);

  useEffect(() => {
    getColorPalettes().then(resp => {
      if (resp?.success && Array.isArray(resp.data)) {
        setColorPalettes(resp.data);
      }
    }).catch(console.error);
  }, []);

  useEffect(() => {
    const fetchSellerProductsList = async () => {
      try {
        const res = await GetSellerProducts({ limit: 100 });
        if (res?.data && Array.isArray(res.data)) {
          setProductsList(res.data);
        } else if (res?.data?.products && Array.isArray(res.data.products)) {
          setProductsList(res.data.products);
        }
      } catch (err) {
        console.error("Error fetching seller products list:", err);
      }
    };

    fetchSellerProductsList();
  }, []);

  const currentIndex = productsList.findIndex(
    (p) => (p._id || p.product_id) === o_id
  );

  const prevProduct =
    productsList.length > 1 && currentIndex !== -1
      ? productsList[(currentIndex - 1 + productsList.length) % productsList.length]
      : productsList.length > 1
      ? productsList[0]
      : null;

  const nextProduct =
    productsList.length > 1 && currentIndex !== -1
      ? productsList[(currentIndex + 1) % productsList.length]
      : productsList.length > 1
      ? productsList[1] || productsList[0]
      : null;

  const scrollSliderLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollSliderRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };
  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  };
//   const handleSendMessage = async () => {
//     const user = getUser(ROLE.USER);
//     console.log("Current User:", user);
//     if (!user || !user.phone_number) {
//       Swal.fire({
//         icon: "error",
//         text: "Please login to send message",
//       });
//       return;
//     }
// 
//     if (!message.trim()) {
//       Swal.fire({
//         icon: "error",
//         text: "Please enter a message",
//       });
//       return;
//     }
// 
// 
//     try {
//       setSending(true);
//       const payload = {
//         o_id,
//         phone_number: phone_number,
//         quantity,
//         message
//       };
//       console.log("Sending WhatsApp payload:", payload);
//       const response = await sendWhatsappMessage(payload);
//       if (response.success) {
//         Swal.fire({
//           icon: "success",
//           text: "Message sent successfully!",
//         });
//         setMessage("");
//         setQuantity(1);
//         document.getElementById("message_on_whatsapp").close();
//       } else {
//         Swal.fire({
//           icon: "error",
//           text: response.message || "Failed to send message",
//         });
//       }
//     } catch (err) {
//       console.error("Error sending message:", err);
//       Swal.fire({
//         icon: "error",
//         text: err.message || "Something went wrong",
//       });
//     } finally {
//       setSending(false);
//     }
//   };

  if (loading) {
    return (
      <div className="product-details py-10">
        <div className="container">
          <div className="text-center py-20 flex flex-col items-center gap-4">
            <div className="loading loading-spinner loading-lg text-[var(--primary-400)]"></div>
            <p className="body-lg text-zinc-500">{t("product_details.loading")}</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="product-details py-10">
        <div className="container">
          <div className="max-w-md mx-auto text-center py-20 px-6 border border-dashed border-zinc-200 rounded-3xl">
            <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
              </svg>
            </div>
            <p className="headings-h3 text-zinc-950 mb-2">{error || t("product_details.not_found")}</p>
            <p className="body-md text-zinc-500 mb-6">{t("product_details.error_subtitle")}</p>
            <button onClick={() => {
              if (window.history.state && window.history.state.idx > 0) {
                navigate(-1);
              } else {
                navigate("/advertiser/products");
              }
            }} className="btn btn-outline">{t("btn_back")}</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="product-details py-8 lg:py-16">
        <div className="container">
          {/* Top Bar for Next / Prev Product Navigation */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-6 pb-4 border-b border-zinc-100">
            {/* Left group: Back & Mobile Share */}
            <div className="flex items-center justify-between sm:justify-start gap-2 w-full sm:w-auto">
              <button
                type="button"
                onClick={() => {
                  if (window.history.state && window.history.state.idx > 0) {
                    navigate(-1);
                  } else {
                    navigate("/advertiser/products");
                  }
                }}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl border border-zinc-200 text-zinc-600 hover:bg-zinc-50 hover:text-zinc-950 text-xs font-semibold transition-all shadow-2xs"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-3.5 h-3.5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                </svg>
                {t("btn_back") || "Back"}
              </button>

              {/* Share Button (Mobile row 1) */}
              <button
                type="button"
                onClick={() => setShowShareModal(true)}
                className="inline-flex sm:hidden items-center gap-1.5 px-3 py-1.5 rounded-xl border border-zinc-200 hover:border-[var(--secondary-500)] text-zinc-700 hover:text-[var(--secondary-500)] bg-white text-xs font-semibold shadow-2xs transition-all active:scale-95"
                title="Share Product"
              >
                <Share2 className="w-3.5 h-3.5 text-[var(--secondary-500)]" />
                <span>Share</span>
              </button>
            </div>

            {/* Right group: Prev/Next product and Desktop Share */}
            <div className="flex items-center gap-2 w-full sm:w-auto">
              <button
                type="button"
                onClick={() => setShowShareModal(true)}
                className="hidden sm:inline-flex items-center gap-1.5 px-3.5 py-2 rounded-xl border border-zinc-200 hover:border-[var(--secondary-500)] hover:text-[var(--secondary-500)] text-xs font-semibold text-zinc-700 bg-white shadow-2xs transition-all active:scale-95 group shrink-0"
                title="Share Product"
              >
                <Share2 className="w-3.5 h-3.5 text-[var(--secondary-500)] group-hover:scale-110 transition-transform" />
                <span>Share</span>
              </button>

              {prevProduct && (
                <button
                  type="button"
                  onClick={() => navigate(`/advertiser/product-details?o_id=${prevProduct._id || prevProduct.product_id}`, { replace: true })}
                  className="flex-1 sm:flex-initial inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl bg-zinc-100 hover:bg-zinc-200 text-xs font-semibold text-zinc-800 transition-all shadow-2xs group min-w-0"
                  title={prevProduct.title}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5 shrink-0 group-hover:-translate-x-0.5 transition-transform">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                  </svg>
                  <span className="hidden md:inline shrink-0">Prev:</span>
                  <span className="font-bold truncate max-w-[110px] sm:max-w-[140px]">{prevProduct.title}</span>
                </button>
              )}

              {nextProduct && (
                <button
                  type="button"
                  onClick={() => navigate(`/advertiser/product-details?o_id=${nextProduct._id || nextProduct.product_id}`, { replace: true })}
                  className="flex-1 sm:flex-initial inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl bg-[var(--primary-400)] hover:opacity-90 text-white text-xs font-semibold transition-all shadow-2xs group min-w-0"
                  title={nextProduct.title}
                >
                  <span className="hidden md:inline shrink-0">Next:</span>
                  <span className="font-bold truncate max-w-[110px] sm:max-w-[140px]">{nextProduct.title}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5 shrink-0 group-hover:translate-x-0.5 transition-transform">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                  </svg>
                </button>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            {/* Left: Product Image & Slider */}
            <div className="product-image-container lg:sticky lg:top-24">
              <ProductImageZoomer
                images={product?.images && product.images.length > 0 ? product.images : [{ url: product?.image || "/images/banner5.png" }]}
                fallbackImage={product?.image || "/images/banner5.png"}
                activeImageIndex={activeImageIndex}
                setActiveImageIndex={setActiveImageIndex}
                productTitle={product?.title || t("common.fallback_product_title")}
                showFavouriteButton={false}
                colorPalettes={colorPalettes}
                onPrevImage={handlePrevImage}
                onNextImage={handleNextImage}
              />
            </div>

            {/* Right: Product Content */}
            <div className="product-info-container flex flex-col gap-6">
              <div className="product-header flex flex-col gap-3">
                <div className="flex flex-col gap-1">
                  {product.category?.title && (
                    <span className="headings-h6 text-primary-400 uppercase tracking-widest">
                      {product.category.title}
                    </span>
                  )}
                  <h1 className="headings-h1 text-zinc-950">
                    {product.title || t("product_details.fallback_title")}
                  </h1>
                </div>
                {/* Store & Seller Details Section */}
                {(() => {
                  const storeName = product.store_name || product.seller?.store_name || product.seller_store_name || product.seller_name || product.brand || "Store";
                  const storeAddress = product.store_address || product.seller_store_address || product.seller?.store_address || product.seller?.store_location?.store_address;
                  const storeImage = product.store_image || product.seller_store_image || product.seller?.store_image;
                  const sellerName = product.seller_name || product.seller?.name;

                  return (
                    <div className="bg-zinc-50 border border-zinc-200/80 rounded-2xl p-4 flex flex-col gap-3">
                      <div className="flex items-center justify-between gap-3">
                        <div className="flex items-center gap-3">
                          <AvatarImage
                            src={storeImage}
                            name={storeName || sellerName}
                            alt={storeName}
                            className="w-12 h-12 rounded-full object-cover border border-zinc-200 shadow-sm shrink-0"
                            style={{ fontSize: "20px" }}
                          />
                          <div>
                            <h4 className="headings-h5 text-zinc-950 font-semibold leading-snug">
                              {storeName}
                            </h4>
                            {sellerName && sellerName !== storeName && (
                              <p className="text-xs text-zinc-500 font-medium">
                                By {sellerName}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      {storeAddress && (
                        <div className="flex items-start gap-2 text-zinc-600 text-xs font-medium pt-2 border-t border-zinc-200/60">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.75} stroke="currentColor" className="w-4 h-4 text-red-500 shrink-0 mt-0.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                          </svg>
                          <span className="leading-tight">{storeAddress}</span>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>

              <div className="h-[1px] w-full bg-zinc-100" />

              <div className="price-section flex flex-col gap-1">
                <span className="headings-h6 text-zinc-400 uppercase tracking-wider">{t("product_details.price_label")}</span>
                <div className="flex items-baseline gap-2">
                  <span className="headings-h2 text-zinc-950">
                    {product.isAskForPrice || product.price == null || product.price === ""
                      ? t("ask_to_seller")
                      : `INR ${product.price}`}
                  </span>
                </div>
              </div>

              <div className="description-section flex flex-col gap-2">
                <span className="headings-h6 text-zinc-400 uppercase tracking-wider">{t("products.description")}</span>
                <p className="body-sm text-zinc-600 leading-relaxed">
                  {product.description || t("product_details.description_placeholder")}
                </p>
              </div>

              {product.attributes && Object.keys(product.attributes).length > 0 && (
                <div className="attributes-section flex flex-col gap-4">
                  {Object.entries(product.attributes).map(([key, value]) => {
                    const isColor = key.toLowerCase().includes('color') || key.toLowerCase().includes('colour');
                    return (
                    <div key={key} className="flex flex-col gap-1.5">
                      <span className="text-xs font-bold text-zinc-400 uppercase tracking-wider">{getAttributeLabel(key, t)}</span>
                      <div className="flex flex-wrap gap-2">
                        {Array.isArray(value) ? (
                          value.map((v, i) => {
                            const valName = typeof v === 'object' && v !== null ? v.name : v;
                            const dotStyle = getColorDotStyle(v, colorPalettes);
                            return (
                            <span 
                              key={i} 
                              onClick={() => isColor && handleColorClick(valName)}
                              className={`text-[11px] px-3 py-1 bg-zinc-50 text-zinc-700 rounded-md border border-zinc-200 font-medium flex items-center gap-1.5 ${isColor ? "cursor-pointer hover:border-zinc-400 hover:bg-zinc-100 transition-all" : ""}`}
                            >
                              {isColor && (
                                <span 
                                  className="w-2.5 h-2.5 rounded-full inline-block shrink-0" 
                                  style={dotStyle}
                                />
                              )}
                              {valName}
                            </span>
                          )})
                        ) : (
                          (() => {
                            const valName = typeof value === 'object' && value !== null ? value.name : value;
                            const dotStyle = getColorDotStyle(value, colorPalettes);
                            return (
                          <span 
                            onClick={() => isColor && handleColorClick(valName)}
                            className={`text-[11px] px-3 py-1 bg-zinc-50 text-zinc-700 rounded-md border border-zinc-200 font-medium flex items-center gap-1.5 ${isColor ? "cursor-pointer hover:border-zinc-400 hover:bg-zinc-100 transition-all" : ""}`}
                          >
                            {isColor && (
                              <span 
                                className="w-2.5 h-2.5 rounded-full inline-block shrink-0" 
                                style={dotStyle}
                              />
                            )}
                            {valName}
                          </span>
                            );
                          })()
                        )}
                      </div>
                    </div>
                    );
                  })}
                </div>
              )}
              
              <div className="flex items-center gap-4 pt-2">
                <button
                  type="button"
                  onClick={() => setShowShareModal(true)}
                  className="btn bg-white hover:bg-zinc-50 border border-zinc-300 hover:border-[var(--secondary-500)] text-zinc-800 font-bold !h-[50px] !min-h-[50px] !rounded-xl !p-0 shadow-sm transition-all active:scale-95 w-full sm:w-auto"
                >
                  <div className="flex items-center justify-center gap-2 h-full w-full px-6">
                    <Share2 className="w-4 h-4 text-[var(--secondary-500)] shrink-0" />
                    <span className="font-bold whitespace-nowrap text-sm">Share Product</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <dialog id="message_on_whatsapp" className="modal p-[15px]">
        <div className="modal-box max-w-[515px] !w-full">
          <h2 className="headings-h2 text-center text-zinc-800 mb-4">
            Message on WhatsApp
          </h2>

          <div className="form-group">
            <label>Select Quantity</label>
            <select
              className="form-control-custom"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea
              className="form-control-custom !h-[120px]"
              value={message}
              // onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <button
            className="btn btn-pri w-full"
            // onClick={handleSendMessage}
            disabled={sending}
          >
            {sending ? "Sending..." : "Send Purchase Request"}
          </button>
        </div>
        <form method="dialog">
          {/* if there is a button in form, it will close the modal */}
          <button className="bg-white subtitle-2 flex items-center gap-[5px] px-[15px] py-[10px] rounded-full">
            <img src="/images/close.svg" alt="close" />
            <span className="subtitle-2 bold">{t("product_details.close")}</span>
          </button>
        </form>
      </dialog>

      <dialog id="instructions" className="modal p-[15px]">
        <div className="modal-box max-w-[515px] !w-full !rounded-3xl border-none shadow-2xl">
          <h2 className="headings-h1 text-zinc-900 mb-4">{t("product_details.instructions")}</h2>
          <div className="flex flex-col gap-4">
            <p className="body-md text-zinc-600 !leading-[1.6]">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
            <p className="body-md text-zinc-600 !leading-[1.6]">
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
            </p>
            <button
              className="btn btn-pri w-full overflow-hidden mt-4"
              onClick={() => document.getElementById("instructions").close()}
            >
              <div className="flex items-center justify-center h-full w-full">
                <span className="font-bold leading-none">{t("product_details.close")}</span>
              </div>
            </button>
          </div>
        </div>
      </dialog>

      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        product={product}
      />
    </>
  );
}

export default Details;
